import React from 'react'

import { IconPropsType } from '../types'

const GoogleMapsIcon = (props: IconPropsType): React.ReactElement => {
   const { width = 20, height = 20, ...rest } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 20 20'
         fill='none'
         {...rest}
      >
         <path
            d='M10 0C5.9657 0 2.69531 3.27242 2.69531 7.30863C2.69531 11.7521 5.73992 12.7992 7.33731 15.5235C8.82441 18.0588 8.82562 20 10 20C11.2179 20 11.141 18.1916 12.6627 15.5236C14.184 12.8551 17.3047 11.7521 17.3047 7.30863C17.3047 3.27242 14.0343 0 10 0ZM10 10.1095C8.49078 10.1095 7.26727 8.88531 7.26727 7.37547C7.26727 6.62012 7.57313 5.93684 8.06777 5.44187C8.56238 4.9473 9.24539 4.64105 10 4.64105C11.5092 4.64105 12.7323 5.8652 12.7323 7.37547C12.7323 8.88531 11.5092 10.1095 10 10.1095Z'
            fill='#4CAF50'
         />
         <path
            d='M9.99995 0C9.79663 0 9.59538 0.00871094 9.39624 0.025C13.148 0.332188 16.0972 3.47582 16.0972 7.30863C16.0972 11.7521 12.9765 12.8551 11.4552 15.5235C10.25 17.6367 10.0475 19.2104 9.41026 19.7736C9.57362 19.9208 9.76288 20 9.99995 20C11.2178 20 11.1409 18.1916 12.6626 15.5236C14.1839 12.8551 17.3046 11.7521 17.3046 7.30863C17.3046 3.27242 14.0342 0 9.99995 0Z'
            fill='#43A047'
         />
         <path
            d='M8.06766 5.4416L3.26508 10.2468C2.91379 9.44629 2.69531 8.49934 2.69531 7.30832C2.69531 5.30687 3.49945 3.49363 4.80172 2.17383L8.06766 5.4416Z'
            fill='#F44336'
         />
         <path
            d='M11.9512 9.28934C12.4344 8.79617 12.7324 8.12067 12.7324 7.37555C12.7324 5.86527 11.509 4.64117 9.99997 4.64117C9.24524 4.64117 8.56216 4.94731 8.06763 5.44211L12.9055 0.601562C14.6348 1.35215 16.0164 2.7527 16.7435 4.49516L11.9514 9.28988L11.9512 9.28934Z'
            fill='#42A5F5'
         />
         <path
            d='M12.9056 0.601562L12.4978 1.00961C14.1203 1.96695 15.3407 3.53355 15.8442 5.39508L16.7436 4.49516C16.0165 2.75266 14.6349 1.35215 12.9056 0.601562Z'
            fill='#2196F3'
         />
         <path
            d='M11.9515 9.28914L6.67701 14.5665C5.53022 13.1211 4.05885 12.0585 3.26514 10.2466L8.06771 5.44141C7.57318 5.93621 7.26721 6.61969 7.26721 7.37484C7.26721 8.88465 8.49064 10.1087 10.0001 10.1087C10.7644 10.1087 11.4554 9.79473 11.9513 9.28859L11.9515 9.28914Z'
            fill='#FFC107'
         />
         <path
            d='M12.9056 0.601406L8.0677 5.44199L4.80176 2.17426C6.12629 0.831797 7.96617 0 10.0001 0C11.0327 0 12.0154 0.214531 12.9056 0.601406Z'
            fill='#1E88E5'
         />
         <path
            d='M9.99999 0C9.79671 0 9.59546 0.00867188 9.39636 0.025C9.39632 0.025 9.39628 0.0250391 9.39624 0.0250391C10.5217 0.117188 11.5747 0.464805 12.4978 1.00945L12.9056 0.601406C12.0153 0.214531 11.0326 0 9.99999 0Z'
            fill='#1976D2'
         />
      </svg>
   )
}
export default GoogleMapsIcon
